<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div v-show="view==='list'" class="main-content">
        <search-item
          ref="searchItem"
          :config-module="configModule"
          :expand-adv="true"
          :show-simple="false"
          :custom-search-items="customSearchItems"
          @advSearchItemCallBack="queryHandler"
        >
          <div slot="operations">
            <el-button type="success" :disabled="!selectedRow" no="view" @click="detail">{{ $t('CargoMsg.Cargo_View') }}</el-button>
            <el-button v-if="!look" type="primary" :disabled="!selectedRow || selectedRow.status === SystemConstants.PRICE_STATUS_NORMAL.code" no="edit" @click="edit">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
            <el-button v-if="!look" type="primary" :disabled="!selectedRow" no="copy" @click="copy">{{ this.$t('CargoMsg.Cargo_Copy') }}</el-button>
            <el-button v-if="!look" type="primary" no="add" @click="add">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
            <el-button v-if="!look" type="primary" no="shelving" @click="shelving">{{ $t('CargoMsg.Cargo_Shelving') }}</el-button>
            <el-button v-if="!look" type="primary" no="unShelving" @click="unShelving">{{ $t('SystemMaintenance.Remove') }}</el-button>
          </div>
        </search-item>
        <div style="flex-grow: 1;min-height: 350px;">
          <cargo-ag-grid-wrapper
            config-module="2025050226"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :show-selected-color="false"
            :check-sub-record="false"
            style="height: 100%;"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="2025050226"
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="fetchDataByPage"
          />
        </div>
      </div>
      <!--尾程 运价详情-->
      <price-last-mile-detail
        v-if="view==='detail'"
        ref="pricePrePortLastMileDetail"
        :look="look"
        source="CarFormTab"
        @back="back"
        @cancel="view = 'list'"
      />
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import CarFormTabDetail from '@/components/Cargo/CarForm/carFormTabDetail'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import PricePrePortLastMileList from '@/components/Cargo/Price/pricePrePortLastMileList'
import priceLastMileDetail from '@/components/Cargo/Price/priceLastMileDetail'

export default {
  name: 'PriceLastMileList',
  components: {
    CarFormTabDetail, cargoAgGridWrapper, searchItem, cargoAdvanceSelect, priceLastMileDetail },
  props: {
    source: { type: String, default: 'priceInput' } // priceInput-运价输入 priceLook-运价查询
  },
  data() {
    return {
      view: 'list',
      type: SystemConstants.PRICE_QUOTATION_TYPE_LAST_MILE.code,
      SystemConstants,
      loading: false,
      isAdvancedQuery: false, // 是否为高级查询
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        context: {
          componentParent: this
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.selectedRows = this.gridApi.getSelectedRows()
        },
        // 行点击触发事件
        onRowClicked: (event) => { this.selectedRow = event.data },
        onRowDoubleClicked: this.onRowDoubleClickedHandler
      },
      columnDefs: [
        {
          headerName: '', width: 55, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EndRouteRateCode'),
          field: 'priceNo',
          colId: 'priceNo',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
          field: 'pod',
          colId: 'pod',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.getPodLabel(params.data)
          }
        },
        // {
        //   headerName: this.$t('CargoMsg.Cargo_DeliveryAddressType'),
        //   colId: 'deliveryAddressType',
        //   field: 'deliveryAddressType',
        //   width: 120,
        //   cellRenderer: (params) => {
        //     return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.DELIVERY_ADDRESS_TYPES)
        //   }
        // },
        // {
        //   headerName: this.$t('SeaExport.Addr'),
        //   field: 'address',
        //   colId: 'address',
        //   width: 200
        // },
        // {
        //   headerName: this.$t('CargoMsg.Cargo_WarehouseCode2'),
        //   field: 'warehouseCode',
        //   colId: 'warehouseCode',
        //   width: 200
        // },
        {
          headerName: this.$t('CargoMsg.Cargo_ShippingAddress'),
          field: 'deliveryAddress',
          colId: 'deliveryAddress',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.getDeliveryAddressLabel(params.data)
          },
          filterParams: {},
          filterValueGetter: params => {
            return ColumnUtils.getDeliveryAddressLabel(params.data)
          }
        },
        {
          headerName: this.$t('FileHistory.ProxyName'),
          field: 'agentName',
          colId: 'agentName',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: '20GP',
          field: 'gp20',
          colId: 'gp20',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.getEqSizeLabel(params.data, 'gp20')
          }
        },
        // {
        //   headerName: '20HC', field: 'hc20', colId: 'hc20', width: 200
        // },
        {
          headerName: '40GP', field: 'gp40', colId: 'gp40', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.getEqSizeLabel(params.data, 'gp40')
          }
        },
        {
          headerName: '40HC', field: 'hc40', colId: 'hc40', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.getEqSizeLabel(params.data, 'hc40')
          }
        },
        {
          headerName: '45HC', field: 'hc45', colId: 'hc45', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.getEqSizeLabel(params.data, 'hc45')
          }
        },
        {
          headerName: '20NOR', field: 'nor20', colId: 'nor20', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.getEqSizeLabel(params.data, 'nor20')
          }
        },
        {
          headerName: '40NOR', field: 'nor40', colId: 'nor40', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.getEqSizeLabel(params.data, 'nor40')
          }
        },
        {
          headerName: this.$t('Pricing.BeginDate'),
          width: 100,
          valueGetter: params => {
            return ColumnUtils.dateRangeLabelFunc(params.data.beginDate, params.data.endDate)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Status'),
          field: 'status',
          colId: 'status',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.PRICE_STATUS)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remarks',
          colId: 'remarks',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Creator'),
          field: 'createdBy',
          colId: 'createdBy',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.DateOfCreation2'),
          field: 'dateCreated',
          colId: 'dateCreated',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UpdatePerson'), colId: 'modifiedBy', field: 'modifiedBy',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('SeaExport.DateModified'), colId: 'dateModified', field: 'dateModified',
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }
      ],
      rowData: [],
      selectedRows: [],
      selectedRow: null,
      gridApi: null,
      customSearchItems: [],
      filter: {
        type: SystemConstants.PRICE_QUOTATION_TYPE_LAST_MILE.code,
        total: 0,
        pageNum: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    look() {
      return this.source === 'priceLook'
    },
    configModule() {
      return this.source === 'priceLook' ? '219213' : '119213'
    }
  },
  async created() {
    this.customSearchItems = await this.getLastCustomSearchItems()
  },
  methods: PricePrePortLastMileList.methods
}
</script>

<style scoped lang="scss">
.input-label {
  display: inline-block;
  width: 60px;
  color: #666666;
}
.el-form{
  /deep/ .el-input__inner{
    width: 300px;
  }
}
</style>
